import { requestGet } from '@/utils/request';

const api = {
	LIST: '/member/user_account_list',
};

export async function userAccountList(queryParams) {
	return requestGet(api.LIST, queryParams);
}
